import { testimonials as mockTestimonials } from '@/mocks/testimonials';
import type { Testimonial } from '@/domain/types';

export const testimonials: Testimonial[] = mockTestimonials;

export function getTestimonialsByProduct(productName: string) {
  return testimonials.filter((testimonial) => testimonial.product === productName);
}
